import type { OutboxHydrationState } from '@Domain/Ports/Outbox/OutboxPort';
import useOutboxPort from '@UI/Providers/PortsProvider/Hooks/OutboxRunner/useOutboxPort';
import * as React from 'react';

/** Whether the transfer queue has been read back from the device yet: an absent item means nothing before that. */
const useOutboxHydration = (): OutboxHydrationState => {
	const outboxPort = useOutboxPort();

	const subscribe = React.useCallback(
		(onStoreChange: () => void): (() => void) => outboxPort.subscribe(() => onStoreChange()),
		[outboxPort],
	);

	const getSnapshot = React.useCallback(
		(): OutboxHydrationState => outboxPort.hydrationState(),
		[outboxPort],
	);

	return React.useSyncExternalStore(subscribe, getSnapshot);
};

export default useOutboxHydration;
